import React from "react";
import bmtcLogo from "../../assets/images/bmtc-logo.png";
import nammaBmtcIcon from "../../assets/images/namma-bmtc-icon.png";
import "./BMTCSupport.css";

function BMTCSupport() {
  return (
    <div className="bmtc-support-page">
      <header className="bmtc-support-header">
        <div className="bmtc-support-wrap">
          <img src={bmtcLogo} alt="BMTC" />
        </div>
      </header>

      <main>
        <section className="bmtc-support-hero">
          <div className="bmtc-support-wrap bmtc-support-hero-grid">
            <div>
              <span className="bmtc-support-eyebrow">Customer Support</span>
              <h1>We're here to help</h1>
              <p>Email or call us.</p>
            </div>

            <svg viewBox="0 0 500 360" role="img" aria-label="A BMTC bus with a support chat bubble">
              {/* road */}
              <rect x="20" y="300" width="460" height="6" rx="3" fill="#FFFFFF" opacity="0.18" />
              <rect x="60" y="322" width="80" height="4" rx="2" fill="#FFFFFF" opacity="0.12" />
              <rect x="200" y="322" width="120" height="4" rx="2" fill="#FFFFFF" opacity="0.12" />
              <rect x="380" y="322" width="60" height="4" rx="2" fill="#FFFFFF" opacity="0.12" />
              {/* bus body */}
              <rect x="40" y="150" width="380" height="140" rx="28" fill="#FFFFFF" />
              <rect x="40" y="248" width="380" height="18" fill="#4D9EFF" />
              <path d="M392 150h0a28 28 0 0 1 28 28v70h-56v-98z" fill="#E7EDF6" />
              {/* windows */}
              <rect x="64" y="172" width="64" height="52" rx="10" fill="#88BEFF" />
              <rect x="140" y="172" width="64" height="52" rx="10" fill="#88BEFF" />
              <rect x="216" y="172" width="64" height="52" rx="10" fill="#88BEFF" />
              <rect x="292" y="172" width="58" height="52" rx="10" fill="#88BEFF" />
              <rect x="370" y="172" width="38" height="70" rx="10" fill="#0A3A8C" opacity="0.85" />
              {/* headlight */}
              <rect x="404" y="262" width="16" height="10" rx="4" fill="#FFD66B" />
              {/* wheels */}
              <circle cx="120" cy="292" r="28" fill="#072A66" />
              <circle cx="120" cy="292" r="11" fill="#E7EDF6" />
              <circle cx="340" cy="292" r="28" fill="#072A66" />
              <circle cx="340" cy="292" r="11" fill="#E7EDF6" />
              {/* chat bubble */}
              <path d="M300 20h150a26 26 0 0 1 26 26v62a26 26 0 0 1-26 26h-96l-30 26v-26h-24a26 26 0 0 1-26-26V46a26 26 0 0 1 26-26z" fill="#4D9EFF" />
              {/* headset in bubble */}
              <path d="M350 92v-14a25 25 0 0 1 50 0v14" fill="none" stroke="#FFFFFF" strokeWidth="7" strokeLinecap="round" />
              <rect x="342" y="80" width="16" height="26" rx="6" fill="#FFFFFF" />
              <rect x="392" y="80" width="16" height="26" rx="6" fill="#FFFFFF" />
              <path d="M400 106c0 10-8 14-18 14" fill="none" stroke="#FFFFFF" strokeWidth="5" strokeLinecap="round" />
              <circle cx="380" cy="120" r="5" fill="#FFFFFF" />
              {/* small bubble */}
              <rect x="70" y="70" width="110" height="46" rx="23" fill="#FFFFFF" opacity="0.16" />
              <circle cx="102" cy="93" r="5" fill="#FFFFFF" />
              <circle cx="125" cy="93" r="5" fill="#FFFFFF" />
              <circle cx="148" cy="93" r="5" fill="#FFFFFF" />
            </svg>
          </div>
        </section>

        <section className="bmtc-support-contact">
          <div className="bmtc-support-wrap bmtc-support-cards">
            <a className="bmtc-support-card" href="mailto:complaints@mybmtc.com">
              <span className="bmtc-support-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="3" y="5" width="18" height="14" rx="2" />
                  <path d="m3 7 9 6 9-6" />
                </svg>
              </span>
              <span>
                <span className="bmtc-support-card-label">Email us</span>
                <span className="bmtc-support-card-value">complaints@<wbr />mybmtc.com</span>
              </span>
            </a>

            <a className="bmtc-support-card" href="tel:+918022483777">
              <span className="bmtc-support-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1 1 .4 1.9.7 2.8a2 2 0 0 1-.5 2.1L8 9.9a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.4c.9.3 1.8.6 2.8.7a2 2 0 0 1 1.7 2z" />
                </svg>
              </span>
              <span>
                <span className="bmtc-support-card-label">Call us</span>
                <span className="bmtc-support-card-value">080-22483777</span>
              </span>
            </a>
          </div>
        </section>
      </main>

      <footer className="bmtc-support-footer">
        <div className="bmtc-support-wrap bmtc-support-footer-inner">
          <img src={nammaBmtcIcon} alt="" />
          <span>&copy; Bangalore Metropolitan Transport Corporation</span>
        </div>
      </footer>
    </div>
  );
}

export default BMTCSupport;
